<template>
	<div class="page-mdl">
		<div class="index-top">
			<div class="logo">
				<img src="../../static/img/logo.png" >
				<!-- <img src="../../static/img/logo-small.png" >千校千课开放课程共享服务平台 -->
			</div>

			<!-- banner广告图 -->
			<div class="banner-mdl">
				<van-swipe class="my-swipe" :autoplay="5000" indicator-color="white"  v-if="bannerList.length>0">
				  <van-swipe-item v-for="(item,index) in bannerList" :key="item.bannerId">
					  <img class="img" :src="item.bannerImg" alt=""  @click="goBannerDetail(item)">
				  </van-swipe-item>
				 <!-- <van-swipe-item>2</van-swipe-item>
				  <van-swipe-item>3</van-swipe-item>
				  <van-swipe-item>4</van-swipe-item> -->
				</van-swipe>
			</div>


			<!-- <div class="swiper-container banner-mdl" id="bannerSwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in bannerList" :key="item.bannerId">
						<img class="img" :src="item.bannerImg" alt=""  @click="goBannerDetail(item)">
					</div>
				</div>
				<div class="swiper-pagination"></div>
			</div> -->

			<!-- 导航 -->
			<ul class="nav-list">
				<li v-for="(item,index) in navList" :key="item.columnId" v-if="index>0" @click="navGo(item)">
					<img :src="require('../../static/img/index/nav'+(index)+'.png')" alt="">
					<p>{{item.columnName}}</p>
				</li>
			</ul>
		</div>


		<!-- 课程资源 -->
		<div class="course-mdl">
			<div class="index-head">
				<h3>好课推荐</h3>
				<a href="javascript:;" @click="goUrl('/course')">查看更多</a>
			</div>
			<ul class="course-list">
				<li v-for="(item,index) in courseList" :key="item.courseId" @click="goCourseDetail(item)" >
					<div class="img-box">
						<img :src="item.courseImg || dfImg" alt="">
						<div v-if="item.courseLevelName" class="label">{{item.courseLevelName}}</div>
						<div class="visit">{{item.allChooseCount || 0}}人观看</div>
					</div>
					<div class="info">
						<h4 class="title">{{item.courseName}}</h4>
						<p>{{item.orgName}} | {{item.teacherName}}</p>
						<div class="btm">
							<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
							<div class="date">{{item.termName}}</div>
						</div>
					</div>
				</li>
			</ul>
		</div>


		<!-- 合作院校 -->
		<div class="colleges-mdl">
			<div class="index-head">
				<h3>合作院校</h3>
				<a href="javascript:;" @click="goUrl('/colleges')">查看更多</a>
			</div>
			<div class="swiper-container" id="collegeSwiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in collegesData" :key="item.orgId">
						<div class="colleges-item" @click="goCollegesDetail(item)">
							<div class="box">
								<div class="logo"><img  :src="item.orgLogo || dfImg" alt=""></div>
								<h4>{{item.orgName}}</h4>
								<!-- <h5>{{item.orgEnName}}</h5> -->
							</div>
							<div class="btm">{{item.courseCounts}}门课程  |  {{item.teacherCounts}}名教师</div>
							<img class="bg" src="../../static/img/index/colleges-bg.png" alt="">
						</div>

					</div>
				</div>
			</div>

			<!-- <ul class="colleges-list clearfix" v-if="collegesData">
				<li v-for="(item,index) in [1,2,3,4]" :key="index">
					<div class="box">
						<img class="logo" src="../../static/img/temp/1.png" alt="">
						<h4>南昌大学</h4>
						<h5>Nanchang University</h5>
						<div class="btm">55门课程  |  32名教师</div>
					</div>
				</li>
			</ul> -->
		</div>

		<div class="m-footer">
			<p>技术支持：广州市云奕通科技有限公司</p>
			<p>备案信息：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021034068号</a></p>
		</div>

	</div>
</template>


<script>
// import Swiper from 'swiper';
// import 'swiper/dist/css/swiper.css';
import { Swipe, SwipeItem } from 'vant';
export default {
	components:{
		vanSwipe:Swipe,
		vanSwipeItem:SwipeItem
	},
	data () {
		return {
			bannerList:[],	//广告列表
			courseList:[],	//课程列表

			collegesData:null,	//院校
			newsParentId:'',	//新闻详情父级id
			loginList:[],		//几个登录入口信息
		}
	},

	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.getBanner()
		this.getCourseList()
		this.getColleges()

	},

	computed:{
		navList(){
			return this.$store.state.navList
		}
	},

	methods:{

		//导航页面跳转
		navGo(item){
			let url = ''
			switch(item.columnCode){
				case 1001: url = '/index'; break;		//首页
				case 100203: url = '/course'; break;	//课程中心
				case 100204: url = '/colleges'; break;		//合作院校
				case 100205:
					url = { name:'about',query:{ firstCateId:item.columnId }	}
					break;		//关于我们
				default: 	//栏目页
					url = { name:'news',params:{ firstCateId:item.columnId }	}
			}
			this.goUrl(url)
		},



		//查询门户首页轮播图
		getBanner(){
			this.$axios({
				url:`/jxedu/api/site/slideshowList/2`,
				// params:{
				// 	bannerType:2
				// }
			}).then(res=>{
				let list = res.data
				this.bannerList = list
				// setTimeout(()=>{
				// 	this.loadSwiper()
				// },500)
			})
		},
		//加载幻灯片
		// loadSwiper(){
		// 	this.mySwiper = new Swiper ('#bannerSwiper', {
		// 		loop: true,
		// 		slidesPerView: 1,
		// 		pagination: '.swiper-pagination',
		// 		paginationClickable: true,
		// 		autoplay: 3000,
		// 	})
		// },
		//banner跳转
		goBannerDetail(item){
			if(item.bannerUrl){
				this.goUrl(item.bannerUrl,'outNew')
			}
		},

		//切换新闻动态
		changeNews(index){
			this.newsTagIndex = index
		},


		//查询教学计划课程数据列表
		getCourseList(){
			this.$axios({
				url:`/jxedu/api/site/teachPlanList`,
				params:{
					pageNum:1,
					pageSize:8
				}
			}).then(res=>{
				let list = res.rows
				list.forEach(item=>{
					switch(item.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
						case 0: item.courseLevelName = ''; item.courseLevelClass = ''; break;
						case 1: item.courseLevelName = '省级精品'; item.courseLevelClass = 'blue'; break;
						case 2: item.courseLevelName = '国家精品'; item.courseLevelClass = 'orange'; break;
						case 3: item.courseLevelName = '省级线上一流'; item.courseLevelClass = 'green'; break;
						case 4: item.courseLevelName = '国家线上一流'; item.courseLevelClass = 'green'; break;
					}
					switch(item.offerCoursesStu){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
						case 1: item.offerCoursesName = '即将开课'; item.offerCoursesClass = 'orange'; break;
						case 2: item.offerCoursesName = '开课中'; item.offerCoursesClass = 'blue'; break;
						case 3: item.offerCoursesName = '已结课'; item.offerCoursesClass = 'gray'; break;
						case 4: item.offerCoursesName = '暂未开课'; item.offerCoursesClass = 'gray'; break;
					}
				})
				this.courseList = list
			})
		},


		//查询院校数据
		getColleges(){
			this.$axios({
				url:`/jxedu/api/site/findSiteOrg`,
			}).then(res=>{
				let data = res.data
				this.collegesData = data
				setTimeout(()=>{
					this.loadCollegeSwiper()
				},500)
			})
		},
		//加载幻灯片
		loadCollegeSwiper(){
			this.mySwiper = new Swiper ('#collegeSwiper', {
				loop: true,
				slidesPerView: 2.26,
				//pagination: '.swiper-pagination',
				paginationClickable: true,
				autoplay: 5000,
			})
		},
		//跳转院校详情
		goCollegesDetail(item){
			this.goUrl({name:'collegesDetail',params:{ id:item.orgId }})
		},

	},

}
</script>

<style lang="less" scoped>
@vm: 7.5vw;
@import '~@/static/css/m-course.less';
.page-mdl{ background:#F6F6F6;}
.index-head{
	display:flex; justify-content: space-between; margin-bottom:36/@vm;
	h3{ font-size: 36/@vm; color:#333333; font-weight: bold; }
	a{
		display:inline-block; font-size:24/@vm; height:36/@vm; line-height:36/@vm; color:#999999; padding-right: 30/@vm; position:relative;
		&::after{
			content:''; display:inline-block; width:20/@vm; height:20/@vm; background:url('../../static/img/index/ico-tri1.png') 0 0;
			position:absolute; right:0; top:50%; margin-top:-10/@vm;  background-size: 20/@vm 20/@vm;
		}
		&:hover{ text-decoration: underline; }
	}
}
.index-top{
	padding:60/@vm 32/@vm 40/@vm; background:#fff;
	.logo{
		font-size:40/@vm; line-height:48/@vm; color:#333333;  font-weight: bold; margin-bottom:56/@vm;
		display:flex; align-items: center;
		img{height:54/@vm; margin-right:12/@vm; }
	}
	.banner-mdl{
		width:100%; height:300/@vm; border-radius:12/@vm; background: #D8D8D8; overflow: hidden;
		box-shadow: 0 20/@vm 40/@vm 0 rgba(1, 16, 51, 0.14); margin-bottom:60/@vm;
		img{ width:100%; height: 100%; border-radius:12/@vm; }
	}
	.nav-list{
		display:flex; justify-content: space-between; padding:0 30/@vm;
		li{
			width:100/@vm; text-align: center;
			img{ width:94/@vm; height:94/@vm; display:block; margin:0 auto 22/@vm; }
			p{ font-size:24/@vm; color:#333333; line-height:24/@vm; }
		}
	}
}
.course-mdl{
	padding:40/@vm 32/@vm; background:#fff; margin-top:20/@vm;
}

.colleges-mdl{
	padding:40/@vm 32/@vm; background:#fff; margin-top:20/@vm;
	.colleges-item{
		width: 286/@vm; height: 320/@vm; background: linear-gradient(180deg, #066AEE 0%, #0EA3F8 100%); border-radius: 12/@vm;
		margin-right:20/@vm; float:left; margin-top:20/@vm; position:relative; box-sizing: border-box;
		.box{
			position:relative; top:-20/@vm; padding:0 26/@vm;
			.logo{
				width: 110/@vm; height: 110/@vm; background: #ffffff; border-radius: 10/@vm; border: 2/@vm solid #D9D9D9;
				img{ width:100%; height:100%;  border-radius: 10/@vm;}
			}
			h4{ font-size:32/@vm; color:#fff; margin-top:38/@vm; }
			h5{ font-size:24/@vm; margin-top:12/@vm; color:rgba(255,255,255,.8);  line-height:24/@vm; height:72/@vm; }
		}
		.btm{ font-size:24/@vm; color:#fff; position:absolute; bottom:40/@vm; left:0; width:100%; text-align: left; padding-left:26/@vm; }
		.bg{ width:190/@vm; height:190/@vm; position:absolute; right:-50/@vm; bottom:-24/@vm; }
	}
	// .colleges-list{
	// 	padding-top:20px;
	// 	li{
	// 		.box{
	// 			position:relative; top:-20/@vm; padding:0 0 0 26/@vm;
	// 			.logo{ width: 110/@vm; height: 110/@vm; background: #D8D8D8; border-radius: 10/@vm; border: 2/@vm solid #D9D9D9; }
	// 			h4{ font-size:32/@vm; color:#fff; margin-top:38/@vm; }
	// 			h5{ font-size:24/@vm; margin-top:12/@vm; color:rgba(255,255,255,.8);  line-height:24/@vm; height:72/@vm; }
	// 			.btm{ font-size:24/@vm; color:#fff; }
	// 		}
	// 	}
	// }
}

.m-footer{
	padding:24/@vm 0; text-align: center; background:#fff; margin-top:20/@vm;
	p{ font-size:24/@vm; color:#CCCCCC; line-height:38/@vm;
		a{color:#CCCCCC;}
	 }
}

</style>



// WEBPACK FOOTER //
// src/pages/index/tpl-mobile.vue